import { render, staticRenderFns } from "./OnboardingAndProductTours.vue?vue&type=template&id=2bfd2646&scoped=true&"
import script from "./OnboardingAndProductTours.vue?vue&type=script&lang=js&"
export * from "./OnboardingAndProductTours.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingAndProductTours.vue?vue&type=style&index=0&id=2bfd2646&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfd2646",
  null
  
)

export default component.exports